export default "__VITE_ASSET__DTG6evBa__"